import { Route } from 'react-router-dom';
import { SigninPage } from '@/modules/auth/pages/signin/signin-page';
import { ActivationSuccessPage } from '@/modules/auth/pages/activation-success';
import { AuthLayout } from '@/layout/auth-layout/auth-layout';
import { AccountActivationPage } from '@/modules/auth/pages/account-activation';
import { VerificationFailed } from '@/modules/auth/pages/verification-failed';
import { OidcCallbackPage } from '@/modules/auth/pages/oidc-callback';

export const AuthRoutes = (
  <Route element={<AuthLayout />}>
    <Route path="/login" element={<SigninPage />} />
    <Route path="/login/oidc" element={<OidcCallbackPage />} />
    <Route path="/activate" element={<AccountActivationPage />} />
    <Route path="/oidc/activate/:tenantId" element={<AccountActivationPage />} />
    <Route path="/success" element={<ActivationSuccessPage />} />
    <Route path="/activate-failed" element={<VerificationFailed />} />
  </Route>
);
